import view from './configuration.view.html';
import './configuration.scss';
import paymentDataService from '../../../services/PaymentDataService';
import { BUILDER_PAYMENT_PRODUCT_TYPE_SELECTED } from '../../../events';
const PRODUCT_TYPE_DIGITAL = 'digital';
const PRODUCT_TYPE_PHYSICAL = 'fisico';
class ConfigurationController {
    static $inject = ['$timeout', '$scope', 'PaymentSegmentService'];
    constructor($timeout, $scope, PaymentSegmentService) {
        'ngInject';
        this.configurationData = {
            referenceId: '',
            productType: 'digital',
            items: '',
            value: '',
            textBody: '',
            textFooter: '',
        };
        this.showTextFooter = false;
        this.showInfoTypeProduct = true;
        this.showInfoConfiguration = true;
        //#endregion
        //#region Lifecycle Hooks
        this.$onInit = () => {
            if (this.state && this.PaymentSegmentService?.setState) {
                this.PaymentSegmentService.setState(this.state);
            }
            this.loadSavedData();
            this.$timeout(() => {
                this.$scope.$applyAsync();
            }, 100);
        };
        this.onReferenceIdBlur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.configurationData.referenceId = value;
            this.saveToJSON();
        };
        this.selectDigital = () => {
            this.configurationData.productType = PRODUCT_TYPE_DIGITAL;
            this.saveToJSON();
            this.trackChangeProductType(PRODUCT_TYPE_DIGITAL);
            this.$scope.$applyAsync();
        };
        this.selectFisico = () => {
            this.configurationData.productType = PRODUCT_TYPE_PHYSICAL;
            this.saveToJSON();
            this.trackChangeProductType(PRODUCT_TYPE_PHYSICAL);
            this.$scope.$applyAsync();
        };
        this.onItemsBlur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.configurationData.items = value;
            this.saveToJSON();
        };
        this.onTextBodyBlur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.configurationData.textBody = value;
            this.saveToJSON();
        };
        this.onTextFooterBlur = (event) => {
            const value = event.detail?.value || event.target?.value || '';
            this.configurationData.textFooter = value;
            this.saveToJSON();
        };
        this.toggleTextFooter = (event) => {
            this.showTextFooter = event.detail?.checked || false;
            if (!this.showTextFooter) {
                this.configurationData.textFooter = '';
            }
            this.saveToJSON();
        };
        this.loadSavedData = () => {
            if (!this.state)
                return;
            const savedConfigData = paymentDataService.getConfigurationData(this.state);
            if (savedConfigData) {
                this.configurationData = {
                    ...this.configurationData,
                    ...savedConfigData,
                };
            }
            const savedCustomizeData = paymentDataService.getCustomizeData(this.state);
            if (savedCustomizeData) {
                this.configurationData.textBody = savedCustomizeData.textBody || '';
                this.configurationData.textFooter = savedCustomizeData.textFooter || '';
                this.showTextFooter = !!(savedCustomizeData.textFooter && savedCustomizeData.textFooter.trim());
            }
        };
        this.updateSetVariableAction = () => {
            if (!this.state)
                return;
            const configData = {
                referenceId: this.configurationData.referenceId,
                productType: this.configurationData.productType,
                items: this.configurationData.items,
                value: this.configurationData.value,
            };
            const customizeData = {
                textBody: this.configurationData.textBody,
                textFooter: this.configurationData.textFooter,
            };
            paymentDataService.updateConfigurationData(this.state, configData);
            paymentDataService.updateCustomizeData(this.state, customizeData);
        };
        this.saveToJSON = () => {
            if (!this.state)
                return '';
            this.updateSetVariableAction();
            if (this.onConfigurationChange) {
                this.onConfigurationChange({ configurationData: this.configurationData });
            }
            return JSON.stringify(this.configurationData, null, 2);
        };
        this.getConfigurationJSON = () => {
            return this.saveToJSON();
        };
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.PaymentSegmentService = PaymentSegmentService;
    }
    //#endregion
    //#region Methods
    toggleInfoTypeProduct() {
        this.showInfoTypeProduct = !this.showInfoTypeProduct;
    }
    toggleInfoConfiguration() {
        this.showInfoConfiguration = !this.showInfoConfiguration;
    }
    //#endregion
    //#region tracking
    trackChangeProductType(productType) {
        this.PaymentSegmentService.trackPaymentBlock(BUILDER_PAYMENT_PRODUCT_TYPE_SELECTED, { productType: productType });
    }
}
//#endregion
//#region Constructor
ConfigurationController.$inject = ['$timeout', '$scope', 'PaymentSegmentService'];
ConfigurationController.$inject = [
    '$timeout',
    '$scope',
    'PaymentSegmentService',
];
export const Configuration = {
    controller: ConfigurationController,
    controllerAs: '$ctrl',
    template: view,
    bindings: {
        stateId: '<',
        state: '<',
        onConfigurationChange: '&?',
    },
};
